import { render } from "./sectors.vue?vue&type=template&id=10700290&scoped=true"
import script from "./sectors.vue?vue&type=script&lang=js"
export * from "./sectors.vue?vue&type=script&lang=js"

import "./sectors.vue?vue&type=style&index=0&id=10700290&lang=scss"
import "./sectors.vue?vue&type=style&index=1&id=10700290&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10700290"]])

export default __exports__